module.exports = "../../app/cells/components/modals/setup_wizard/oab_redirect.erb";